import filter from 'lodash/filter'
import { useContext } from './Context'
import { addBoardItemQuery } from './graphql'
import { useError, useMutation } from '@ztechapps/common.hook'

export const useAddBoardItem = () => {
  const { onClose, selectedBoard, entity } = useContext()
  const [updateItems, , { error, loading }] = useMutation({ query: addBoardItemQuery })

  useError(error)

  const onSave = async () => {
    //we need to loop thru all selectedboard
    const checkedBoardOnly = filter(selectedBoard, { checked: true })
    for (const board of checkedBoardOnly) {
      const input = {
        _id: board?._id,
        boardId: board?._id,
        entity: { _id: entity?._id },
      }

      await updateItems({ input })
    }

    onClose()
  }

  return { onSave, loading, error }
}
